import React, { createContext, useContext, useState, ReactNode } from 'react';
import { JobCard } from '../types';

interface JobCardContextType {
  selectedJobCardId: string | null;
  setSelectedJobCardId: (id: string | null) => void;
  editingJobCard: JobCard | null;
  setEditingJobCard: (jobCard: JobCard | null) => void;
}

const JobCardContext = createContext<JobCardContextType | undefined>(undefined);

export const JobCardProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedJobCardId, setSelectedJobCardId] = useState<string | null>(null);
  const [editingJobCard, setEditingJobCard] = useState<JobCard | null>(null);

  return (
    <JobCardContext.Provider
      value={{
        selectedJobCardId,
        setSelectedJobCardId,
        editingJobCard,
        setEditingJobCard,
      }}
    >
      {children}
    </JobCardContext.Provider>
  );
};

export const useJobCardContext = () => {
  const context = useContext(JobCardContext);
  if (context === undefined) {
    throw new Error('useJobCardContext must be used within a JobCardProvider');
  }
  return context;
};
